import React from 'react';
import { Translate, useTranslate } from 'core/translate';
import { combineClassNames } from 'core/css';
import { Price } from './Price';
import { Dagger } from '../../common/notifications/NotificationsTrigger';
import { DoubleDagger } from '../../common/notifications/NotificationsTrigger';
import { withNotifications } from '../../common/notifications/NotificationsContext';

const Line = withNotifications(
  ({ label, labelKey, value, price, className, disclaimer, isDisabled, notifications }) => {
    const { show } = notifications;
    const translate = useTranslate();

    const isDoubleDagger = label == translate('stp.pricing.misc.fee.label.ehf.tires');

    if (!value && !price) {
      return null;
    }

    return (
      <div className={combineClassNames('math-box__line', className)}>
        <span
          onClick={event => {
            disclaimer && show(disclaimer, event);
          }}>
          {label || <Translate value={labelKey} />}
          {disclaimer && (
            !isDoubleDagger ? 
              <Dagger className="notification-trigger--no-right math-box__line--dagger" /> :
              <DoubleDagger disabled={!isDisabled} className={`notification-trigger--no-right ${isDisabled ? 'math-box__line--dagger' : ''}`} />
          )}
        </span>
        {price || <Price value={value} />}
      </div>
    );
  }
);

const TotalLine = props => (
  <Line
    {...props}
    className={combineClassNames('math-box__line--total', props.className)}
  />
);

const SecondaryLine = props => (
  <Line
    {...props}
    className={combineClassNames('math-box__line--secondary', props.className)}
  />
);

const NetLine = props => (
  <Line
    {...props}
    className={combineClassNames('math-box__line--net', props.className)}
  />
);

export { Line, TotalLine, SecondaryLine, NetLine };
